import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FeatureformService {

  constructor() { }

  generarFieldConfigRestore(campos = [], condition = "", visibility = true) {
    const FieldInfos: any[] = [];
    // DESHABILITAR CAMPOS PARA EDICION
    // campos.forEach(element => {
    campos.forEach((item) => {
      FieldInfos.push({
        name: item.name,
        label: item.label,
        required: item.required,
        editable: visibility,
        ...item
      });
    });
    // });
    return FieldInfos;
  }
  generarFieldConfigCondition(campos = [], condition = "", visibility = true) {
    const FieldInfos: any[] = [];
    // DESHABILITAR CAMPOS PARA EDICION
    // campos.forEach(element => {
    campos.forEach((item) => {
      FieldInfos.push({
        name: item.name,
        label: item.label,
        required: item.required,
        editable: visibility,
        ...item
      });
      if (item.name === condition) {
        visibility = false;
      }
    });
    // });
    return FieldInfos;
  }

  generarFieldConfigFilter(campos = [], camposInitial = [], filter = "", fieldPattern = "") {
    let FieldInfos: any[] = [];
    let FieldInfosFilter: any[] = [];
    // DESHABILITAR CAMPOS PARA EDICION
    FieldInfos.push({
      domain: camposInitial[0].domain,
      name: camposInitial[0].name,
      label: camposInitial[0].label,
      required: camposInitial[0].required,
      editable: camposInitial[0].editable,
      ...camposInitial[0]
    });
    for (let index = 1; index < campos.length; index++) {
      let field = camposInitial[index];
      // console.log(field);
      if (campos[index - 1].name === fieldPattern) {
        const element = camposInitial[index];
        const elementInitial = campos[index];
        if (element != null) {
          if (elementInitial.domain != null && elementInitial.domain.codedValues.length > 1) {
            FieldInfosFilter = elementInitial.domain.codedValues.filter(x => x.name.toLowerCase().indexOf(filter.toLowerCase()) > -1);
            if (FieldInfosFilter.length > 0 && FieldInfosFilter != null) {
              FieldInfos.push({
                domain: {
                  codedValues: FieldInfosFilter
                },
                name: element.name,
                label: element.label,
                required: element.required,
                editable: element.editable,
                ...element
              });
            } else {
              FieldInfos.push({
                domain: {
                  codedValues: elementInitial.domain.codedValues
                },
                name: element.name,
                label: element.label,
                required: element.required,
                editable: element.editable,
                ...element
              });
            }
          }
        }
      } else {
        FieldInfos.push({
          domain: field.domain,
          name: field.name,
          label: field.label,
          required: field.required,
          editable: field.editable,
          ...field
        });
      }
    }
    return FieldInfos;
  }
}
